export enum ProgramLocationType {
  ACCOUNT = "ACCOUNT",
  DEPOT = "DEPOT",
  CUSTOMER = "CUSTOMER",
  AREA = 'AREA'
}
